import React from 'react';
import { StorySymbols, CardData } from 'types/story';
import { ISelectionHintContext } from 'client/components/common/SelectionHint/SelectionHintContext';
import CardRenderer from './CardRenderer';

const defaultProps = {
	symbols: {},
};

export type Props = {
	isEditor: boolean;
	treeOptions:
		| { target: 'default'; isCardTree: true }
		| ({ target: 'editor'; isCardTree: true } & ISelectionHintContext['editor']['treeOptions']);
	data: CardData;
	nextDefaultCardId: string;
	symbols?: StorySymbols;
};

export class StoryCard<T = void> extends React.PureComponent<T & Props, any> {
	renderCard() {
		return (
			<CardRenderer
				symbols={this.props.symbols ?? defaultProps.symbols}
				data={this.props.data}
				treeOptions={this.props.treeOptions}
				isEditor={this.props.isEditor}
			/>
		);
	}

	render() {
		return <div className="story-card">{this.renderCard()}</div>;
	}
}
